var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakingGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4625 26.3565C29.7115 25.1724 30.7793 24.2299 34.359 22.885C36.0738 22.2397 35.031 20.8787 35.0779 19.79C35.0989 19.2916 37.0583 19.3909 36.9162 17.4686C36.816 16.1149 33.834 14.1862 33.0215 13.3631C32.5522 12.8882 33.9778 11.5886 32.9738 10.4457C31.6032 8.88362 31.3867 6.16572 30.5572 4.64563C30.5572 4.64563 31.1896 3.67963 30.705 3.13039C26.5244 -1.6019 10.9237 -1.16736 6.9369 5.79741C2.46146 13.6159 2.40169 24.4221 11.7072 30.244C15.8458 32.8326 10.5449 42 10.5449 42H26.9565C26.9565 40.4347 25.1262 34.8196 28.3296 35.0716C31.1129 35.2905 34.5214 35.1701 34.2193 32.0266C34.128 31.0783 34.0206 30.2246 34.6829 29.4387C35.3452 28.6536 36.304 27.2531 33.4625 26.3565Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2191 24.8809L52.4611 26.8775V22.885L37.2191 24.8809Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6019 38.0269L51.2366 34.5692L37.2191 27.0027L49.6019 38.0269Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2366 15.157L49.6019 11.6985L37.2191 22.7243L51.2366 15.157Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_126",
    x: 0,
    y: 0,
    width: 56.4611,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_126",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakingGreen);
export default __webpack_public_path__ + "static/media/speaking-green.9cd72fa11bb28dbf77242d93a19a5cb6.svg";
export { ForwardRef as ReactComponent };